<template>
    <div class="full-modal">
        <div class="btn-exit grow-medium" @click="ExitModal"><i class="pi pi-times"></i></div>
        <h1 class="top-text">{{modalHeaderText}}</h1>
        <textarea v-model="changes" class="note-box" @input="adjustTextAreaHeight" ref="noteTextArea"></textarea>
        <div class="save-btn"
            onmouseup="this.blur();"
            @click="HandleClick()"
            style="padding-right:0.35em; padding-left: 0.35em;"
            :class="{'btn-not-clickable': (!this.saveButtonClickable)}"
            :disabled="btnText === 'Saving...'">
            <div v-if="btnText === 'Saving...'" class="button-content">
                <div class="spinner"></div>
                <span>Saving...</span>
            </div>
            <span v-else>{{btnText}}</span>
        </div>
        <span class="error" v-if="save404 || save500">There was an error saving your changes. <br/> If this issue persists, please contact Dental Menu!</span>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { UpdatePlanDataInDB } from '../../utils/functions'
export default {
    props: {
        mode: String
    },
    data() {
        return {
            changes: "",
            btnText: "Confirm Changes",
            save404: false,
            save500: false,
            modalHeaderText: "Save Changes?",
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleEscape);
        this.$nextTick(() => {
            this.adjustTextAreaHeight(); // Adjust initially in case of pre-filled content
        });
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        ...mapActions(['setNote', 'setUneditedStateToCurrentState']),
        ExitModal() {
            this.$emit('exitModal');
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                this.ExitModal();
            }
        },
        adjustTextAreaHeight() {
            const textArea = this.$refs.noteTextArea;
            textArea.style.height = "auto"; // Reset height to recalculate
            textArea.style.height = textArea.scrollHeight + "px"; // Set new height based on content
        },
        HandleClick() {
            if(this.mode === 'confirm') {
                this.SaveChanges();
            }
            else {
                this.$emit('revert');
                this.ExitModal();
            }
        },
        async SaveChanges() {
            this.save404 = this.save500 = false;
            if(this.btnText == "Changes Saved") {
                return;
            }
                this.btnText = "Saving..."
                const result = await UpdatePlanDataInDB(this.$store.state.id, this.$store.state, this.changes);
                if(result === 404) {
                    this.save404 = true;
                    this.btnText = "Save Changes";
                    return;
                }
                else if(result === 500) {
                    this.save500 = true;
                    this.btnText = "Save Changes";
                    return;
                }
                else {
                    this.planLink += result.data;
                    this.showPlanLink = true;
                    this.$emit('btnPressed');
                    this.btnText = "Changes Saved";
                }
                this.setUneditedStateToCurrentState();
            },
        listChanges() {
            const newPlan = this.$store.state
            const oldPlan = newPlan.uneditedState;
            //check 
            //MISC FROM PLANPRICING.VUE
            Object.keys(newPlan.percentBreakage).forEach(key => {
                if(newPlan.percentBreakage[key] !== oldPlan.percentBreakage[key]) {
                    this.changes += `${this.$store.getters.getPlanTypeFromInt(key)} plan breakage changed from ${oldPlan.percentBreakage[key]}% to ${newPlan.percentBreakage[key]}%\n\n`
                }
            });
            if(newPlan.includeDMFee !== oldPlan.includeDMFee) {
                if(newPlan.includeDMFee) {
                    this.changes += `Included Dental Menu fee in plan prices\n\n`;
                }
                else {
                    this.changes += `Excluded Dental Menu Fee from plan prices\n\n`
                }
            }
            if(newPlan.includeProcessingFee !== oldPlan.includeProcessingFee) {
                if(newPlan.includeProcessingFee) {
                    this.changes += `Included payment processing fee in plan prices\n\n`
                }
                else {
                    this.changes += `Excluded payment processing fee from plan prices\n\n`
                }
            }
            if(newPlan.isPediatric !== oldPlan.isPediatric) {
                if(newPlan.isPediatric) {
                    this.changes += `Changed to pediatric practice\n\n`;
                } else {
                    this.changes += `Changed to adult practice\n\n`;
                }
            }
            if(newPlan.dentalMenuFee !== oldPlan.dentalMenuFee) {
                this.changes += `Dental Menu fee changed from $${oldPlan.dentalMenuFee} to $${newPlan.dentalMenuFee}\n\n`;
            }
            if(newPlan.rewardsPointsPerVisit !== oldPlan.rewardsPointsPerVisit) {
                this.changes += `Rewards Points per visit changed from ${oldPlan.rewardsPointsPerVisit} to ${newPlan.rewardsPointsPerVisit}\n\n`;
            }
            if(newPlan.reimbursementPercentage !== oldPlan.reimbursementPercentage) {
                this.changes += `Reimbursement Percentage changed from ${oldPlan.reimbursementPercentage} to ${newPlan.reimbursementPercentage}\n\n`;
            }
            if(newPlan.includePointsInPlanPrice !== oldPlan.includePointsInPlanPrice) {
                this.changes += `Changed to ${newPlan.includePointsInPlanPrice ? 'include' : 'exclude'} rewards points ${newPlan.includePointsInPlanPrice ? 'in' : 'from'} plan pricing\n\n`;
            }
            if(newPlan.rewardsEnabled !== oldPlan.rewardsEnabled) {
                this.changes += `Rewards program ${newPlan.rewardsEnabled ? 'enabled' : 'disabled'}\n\n`;
            }
            // Handle enrollment fee with backward compatibility for old property name
            const oldEnrollmentFee = oldPlan.enrollmentFee !== undefined ? oldPlan.enrollmentFee : oldPlan.enrollmentFeeFirstVisit;
            const newEnrollmentFee = newPlan.enrollmentFee !== undefined ? newPlan.enrollmentFee : newPlan.enrollmentFeeFirstVisit;
            if(newEnrollmentFee !== oldEnrollmentFee) {
                this.changes += `Enrollment Fee changed from $${oldEnrollmentFee} to $${newEnrollmentFee}\n\n`;
            }
            // Only report firstVisitReimbursement changes if there was a previous non-zero value
            if(newPlan.firstVisitReimbursement !== oldPlan.firstVisitReimbursement && oldPlan.firstVisitReimbursement !== undefined && oldPlan.firstVisitReimbursement !== 0) {
                this.changes += `First Visit Reimbursement changed from ${oldPlan.firstVisitReimbursement} to ${newPlan.firstVisitReimbursement}\n\n`;
            }
            // Only report staffIncentive changes if there was a previous non-zero value
            if(newPlan.staffIncentive !== oldPlan.staffIncentive && oldPlan.staffIncentive !== undefined && oldPlan.staffIncentive !== 0) {
                this.changes += `Staff Incentive changed from $${oldPlan.staffIncentive} to $${newPlan.staffIncentive}\n\n`;
            }
            if(newPlan.StaffIncentiveActive !== oldPlan.StaffIncentiveActive) {
                this.changes += `Staff Incentive ${newPlan.StaffIncentiveActive ? 'enabled' : 'disabled'}\n\n`;
            }
            if(newPlan.existingPatientEnrollmentDiscount !== oldPlan.existingPatientEnrollmentDiscount) {
                this.changes += `Existing Patient Enrollment Discount changed from $${oldPlan.existingPatientEnrollmentDiscount} to $${newPlan.existingPatientEnrollmentDiscount}\n\n`;
            }
            if(newPlan.ExistingMemberDiscountActive !== oldPlan.ExistingMemberDiscountActive) {
                this.changes += `Existing Member Discount ${newPlan.ExistingMemberDiscountActive ? 'enabled' : 'disabled'}\n\n`;
            }
            if(newPlan.baseEnrollmentFee !== oldPlan.baseEnrollmentFee) {
                this.changes += `Base Enrollment Fee changed from $${oldPlan.baseEnrollmentFee} to $${newPlan.baseEnrollmentFee}\n\n`;
            }
            for(let i = 0; i < newPlan.planTypes.length; i++) {
                if(newPlan.planTypes[i] !== oldPlan.planTypes[i]) {
                    this.changes += `Renamed ${oldPlan.planTypes[i]} plans to ${newPlan.planTypes[i]} plans\n\n`;
                }
            }
            const getQuantityForPlanType = (benefit, planTypeIndex) => {
                if (!benefit.planTypes || !benefit.planTypes.length) return 0;
                const entry = benefit.planTypes.find(e => typeof e === 'object' && e && e.planTypeIndex === planTypeIndex);
                if (entry) return entry.quantity ?? 1;
                if (benefit.planTypes.includes(planTypeIndex)) return 1;
                return 0;
            };
            const planTypeIndices = (newPlan.planTypes || []).map((_, i) => i);
            newPlan.benefits.forEach((newBenefit) => {
                const currentID = newBenefit.id;
                if (!oldPlan.benefits.some(benefit => benefit.id === currentID)) {
                    this.changes += `Added benefit- ${newBenefit.name}\n\n`;
                    return;
                }
                const oldBenefit = oldPlan.benefits.find(benefit => benefit.id === currentID);
                planTypeIndices.forEach((planTypeIndex) => {
                    const oldQ = getQuantityForPlanType(oldBenefit, planTypeIndex);
                    const newQ = getQuantityForPlanType(newBenefit, planTypeIndex);
                    const planTypeName = this.$store.getters.getPlanTypeFromInt(planTypeIndex);
                    if (oldQ === 0 && newQ > 0) {
                        this.changes += `Added benefit ${newBenefit.name} to ${planTypeName} plans`;
                        if (newQ > 1) this.changes += ` (quantity: ${newQ})`;
                        this.changes += '\n\n';
                    } else if (oldQ > 0 && newQ === 0) {
                        this.changes += `Removed benefit ${newBenefit.name} from ${planTypeName} plans\n\n`;
                    } else if (oldQ > 0 && newQ > 0) {
                        if (oldQ !== newQ) {
                            this.changes += `Changed quantity of ${newBenefit.name} in ${planTypeName} plans from ${oldQ} to ${newQ}\n\n`;
                        }
                        if (newBenefit.frequencies[planTypeIndex] !== oldBenefit.frequencies[planTypeIndex]) {
                            this.changes += `Changed frequency of ${newBenefit.name} from ${oldBenefit.frequencies[planTypeIndex] === -1 ? 'Each Visit' : 'Every ' + oldBenefit.frequencies[planTypeIndex] + ' months'} to ${newBenefit.frequencies[planTypeIndex] === -1 ? 'Each Visit' : 'Every ' + newBenefit.frequencies[planTypeIndex] + ' months'} in ${planTypeName} plans\n\n`;
                        }
                    }
                });
                if (newBenefit.price !== oldBenefit.price) {
                    this.changes += `Changed price of ${newBenefit.name} from $${oldBenefit.price} to $${newBenefit.price}\n\n`;
                }
                if (newBenefit.name !== oldBenefit.name) {
                    this.changes += `Renamed benefit ${oldBenefit.name} to ${newBenefit.name}\n\n`;
                }
                if (newBenefit.code !== oldBenefit.code) {
                    this.changes += `Changed benefit ${newBenefit.name} code from ${oldBenefit.code} to ${newBenefit.code}\n\n`;
                }
                if (newBenefit.UCR !== oldBenefit.UCR) {
                    this.changes += `Changed benefit ${newBenefit.name} UCR from $${oldBenefit.UCR} to $${newBenefit.UCR}\n\n`;
                }
                if (newBenefit.insuranceReimbursement !== oldBenefit.insuranceReimbursement) {
                    this.changes += `Changed benefit ${newBenefit.name} insurance reimbursement from $${oldBenefit.insuranceReimbursement} to $${newBenefit.insuranceReimbursement}\n\n`;
                }
            });
            //check for any benefits removed during this session
            oldPlan.benefits.forEach((benefit) => {
                let currentID = benefit.id;
                if(!newPlan.benefits.some(benefit => benefit.id === currentID)) {
                    this.changes += `Removed benefit- ${benefit.name}\n\n`;
                }
            });
            //PLANS
            for(let i = 0; i < newPlan.plans.length; i++) {
                let currentNewPlan = newPlan.plans[i];
                let currentOldPlan = oldPlan.plans[i];
                if(currentNewPlan.planName !== currentOldPlan.planName) {
                    this.changes += `Changed ${currentNewPlan.frequency}-month ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan name from "${currentOldPlan.plans[i].planName}" to "${currentNewPlan.plans[i].planName}"\n\n`;
                }
                if(currentNewPlan.isActive !== currentOldPlan.isActive) {
                    if(currentNewPlan.isActive) {
                        this.changes += `Started offering ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plans every ${currentNewPlan.frequency} months\n\n`;
                    }
                    else {
                        this.changes += `Stopped offering ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plans every ${currentNewPlan.frequency} months\n\n`;
                    }
                }
                if(currentNewPlan.price !== currentOldPlan.price) {
                    this.changes += `Changed ${currentNewPlan.frequency}-month ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan price from $${currentOldPlan.price} to $${currentNewPlan.price}\n\n`;
                }
                if(currentNewPlan.annualPrice !== currentOldPlan.annualPrice && currentNewPlan.annualPriceAltered) {
                    this.changes += `Manually set ${currentNewPlan.frequency}-month ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan annual price to $${currentNewPlan.annualPrice}\n\n`;
                }
                if(currentNewPlan.frequency !== currentOldPlan.frequency) {
                    this.changes += `Changed ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan frequency from ${currentOldPlan.frequency} months to ${currentNewPlan.frequency} months\n\n`;
                }
                if(currentNewPlan.planType !== currentOldPlan.planType) {
                    this.changes += `Changed plan type from ${this.$store.getters.getPlanTypeFromInt(currentOldPlan.planType)} to ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)}\n\n`;
                }
                if(currentNewPlan.includeStripeFee !== currentOldPlan.includeStripeFee) {
                    this.changes += `Changed ${currentNewPlan.frequency}-month ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan to ${currentNewPlan.includeStripeFee ? 'include' : 'exclude'} payment processing fee\n\n`;
                }
                if(currentNewPlan.includeDMFee !== currentOldPlan.includeDMFee) {
                    this.changes += `Changed ${currentNewPlan.frequency}-month ${this.$store.getters.getPlanTypeFromInt(currentNewPlan.planType)} plan to ${currentNewPlan.includeDMFee ? 'include' : 'exclude'} Dental Menu fee\n\n`;
                }
            }
            //DISCOUNTS (matched by id so title/description changes are detected correctly)
            const oldMonthlyDiscounts = oldPlan.monthlyDiscounts || [];
            newPlan.monthlyDiscounts.forEach((newDiscount) => {
                const oldDiscount = oldMonthlyDiscounts.find(d => d.id === newDiscount.id);
                if (!oldDiscount) {
                    this.changes += `Created ${newDiscount.title} discount\n\n`;
                    return;
                }
                if(newDiscount.title !== oldDiscount.title) {
                    this.changes += `Changed discount title from "${oldDiscount.title}" to "${newDiscount.title}"\n\n`;
                }
                if(newDiscount.description !== oldDiscount.description) {
                    this.changes += `Changed ${newDiscount.title} discount description from "${oldDiscount.description}" to "${newDiscount.description}"\n\n`;
                }
                if(newDiscount.dollarsOff !== oldDiscount.dollarsOff) {
                    this.changes += `Changed ${newDiscount.title} discount amount from $${oldDiscount.dollarsOff} off/month to $${newDiscount.dollarsOff} off/month\n\n`;
                }
                if(newDiscount.isActive !== oldDiscount.isActive) {
                    if(newDiscount.isActive) {
                        this.changes += `Enabled ${newDiscount.title} discount\n\n`;
                    }
                    else {
                        this.changes += `Disabled ${newDiscount.title} discount\n\n`;
                    }
                }
                // if(newDiscount.isMultiplePatient !== oldDiscount.isMultiplePatient) {
                //     this.changes += `Changed ${newDiscount.title} discount from ${oldDiscount.isMultiplePatient ? 'Multiple Patient' : 'Single Patient'} to ${newDiscount.isMultiplePatient ? 'Multiple Patient' : 'Single Patient'}\n\n`;
                // }
                // if(newDiscount.isSenior !== oldDiscount.isSenior) {
                //     this.changes += `Changed ${newDiscount.title} discount from ${oldDiscount.isSenior ? 'Senior' : 'Non-Senior'} to ${newDiscount.isSenior ? 'Senior' : 'Non-Senior'}\n\n`;
                // }
            });
            oldMonthlyDiscounts.forEach((oldDiscount) => {
                if (!newPlan.monthlyDiscounts.some(d => d.id === oldDiscount.id)) {
                    this.changes += `Removed ${oldDiscount.title} discount\n\n`;
                }
            });
            const oldTreatmentDiscounts = oldPlan.treatmentDiscounts || [];
            newPlan.treatmentDiscounts.forEach((newDiscount) => {
                const oldDiscount = oldTreatmentDiscounts.find(d => d.id === newDiscount.id);
                if (!oldDiscount) {
                    this.changes += `Created ${newDiscount.title} discount\n\n`;
                    return;
                }
                if(newDiscount.title !== oldDiscount.title) {
                    this.changes += `Changed discount title from "${oldDiscount.title}" to "${newDiscount.title}"\n\n`;
                }
                if(newDiscount.description !== oldDiscount.description) {
                    this.changes += `Changed ${newDiscount.title} discount description from "${oldDiscount.description}" to "${newDiscount.description}"\n\n`;
                }
                if(newDiscount.percentOff !== oldDiscount.percentOff) {
                    this.changes += `Changed ${newDiscount.title} discount amount from ${oldDiscount.percentOff}% off to ${newDiscount.percentOff}% off\n\n`;
                }
                if(newDiscount.isActive !== oldDiscount.isActive) {
                    if(newDiscount.isActive) {
                        this.changes += `Enabled ${newDiscount.title} discount\n\n`;
                    }
                    else {
                        this.changes += `Disabled ${newDiscount.title} discount\n\n`;
                    }
                }
                // if(newDiscount.isRestorative !== oldDiscount.isRestorative) {
                //     this.changes += `Changed ${newDiscount.title} discount from ${oldDiscount.isRestorative ? 'Restorative' : 'Non-Restorative'} to ${newDiscount.isRestorative ? 'Restorative' : 'Non-Restorative'}\n\n`;
                // }
                // if(newDiscount.isPerio !== oldDiscount.isPerio) {
                //     this.changes += `Changed ${newDiscount.title} discount from ${oldDiscount.isPerio ? 'Periodontal' : 'Non-Periodontal'} to ${newDiscount.isPerio ? 'Periodontal' : 'Non-Periodontal'}\n\n`;
                // }
            });
            oldTreatmentDiscounts.forEach((oldDiscount) => {
                if (!newPlan.treatmentDiscounts.some(d => d.id === oldDiscount.id)) {
                    this.changes += `Removed ${oldDiscount.title} discount\n\n`;
                }
            });
            //OTHER DISCOUNTS
            const oldOtherDiscounts = oldPlan.otherDiscounts || [];
            newPlan.otherDiscounts.forEach((newDiscount) => {
                const oldDiscount = oldOtherDiscounts.find(d => d.id === newDiscount.id);
                if (!oldDiscount) {
                    this.changes += `Created ${newDiscount.title} other discount\n\n`;
                    return;
                }
                if(newDiscount.title !== oldDiscount.title) {
                    this.changes += `Changed other discount title from "${oldDiscount.title}" to "${newDiscount.title}"\n\n`;
                }
                if(newDiscount.description !== oldDiscount.description) {
                    this.changes += `Changed ${newDiscount.title} other discount description from "${oldDiscount.description}" to "${newDiscount.description}"\n\n`;
                }
                if (oldDiscount.dollarsOff != null || newDiscount.dollarsOff != null) {
                    if(newDiscount.dollarsOff !== oldDiscount.dollarsOff) {
                        this.changes += `Changed ${newDiscount.title} other discount amount from $${oldDiscount.dollarsOff ?? 0} off to $${newDiscount.dollarsOff ?? 0} off\n\n`;
                    }
                } else if (oldDiscount.percentOff != null || newDiscount.percentOff != null) {
                    if(newDiscount.percentOff !== oldDiscount.percentOff) {
                        this.changes += `Changed ${newDiscount.title} other discount amount from ${oldDiscount.percentOff ?? 0}% off to ${newDiscount.percentOff ?? 0}% off\n\n`;
                    }
                }
                if(newDiscount.isActive !== oldDiscount.isActive) {
                    if(newDiscount.isActive) {
                        this.changes += `Enabled ${newDiscount.title} other discount\n\n`;
                    }
                    else {
                        this.changes += `Disabled ${newDiscount.title} other discount\n\n`;
                    }
                }
            });
            oldOtherDiscounts.forEach((oldDiscount) => {
                if (!newPlan.otherDiscounts.some(d => d.id === oldDiscount.id)) {
                    this.changes += `Removed ${oldDiscount.title} other discount\n\n`;
                }
            });
            //ADD-ONS (matched by id so add/remove and benefit changes are detected correctly)
            const oldAddOns = oldPlan.addOns || [];
            newPlan.addOns.forEach((newAddOn) => {
                const oldAddOn = oldAddOns.find(a => a.id === newAddOn.id);
                if (!oldAddOn) {
                    this.changes += `Created ${newAddOn.title} Add-On\n\n`;
                    return;
                }
                if(newAddOn.title !== oldAddOn.title) {
                    this.changes += `Add-On title changed from ${oldAddOn.title} to ${newAddOn.title}\n\n`;
                }
                if(newAddOn.description !== oldAddOn.description) {
                    this.changes += `Changed ${newAddOn.title} Add-On description from ${oldAddOn.description} to ${newAddOn.description}\n\n`;
                }
                if(newAddOn.price !== oldAddOn.price) {
                    this.changes += `Changed ${newAddOn.title} price from ${oldAddOn.price} to ${newAddOn.price}\n\n`;
                }
                if(newAddOn.isActive !== oldAddOn.isActive) {
                    if(newAddOn.isActive) {
                        this.changes += `Enabled ${newAddOn.title} Add-On\n\n`;
                    }
                    else {
                        this.changes += `Disabled ${newAddOn.title} Add-On\n\n`;
                    }
                }
                // Track benefit changes within add-on
                const oldBenefits = oldAddOn.benefits || [];
                const newBenefits = newAddOn.benefits || [];
                newBenefits.forEach((benefitId) => {
                    if (!oldBenefits.includes(benefitId)) {
                        const benefitName = this.getBenefitNameFromPlan(benefitId, newPlan, oldPlan);
                        this.changes += `Added benefit ${benefitName} to ${newAddOn.title} Add-On\n\n`;
                    }
                });
                oldBenefits.forEach((benefitId) => {
                    if (!newBenefits.includes(benefitId)) {
                        const benefitName = this.getBenefitNameFromPlan(benefitId, newPlan, oldPlan);
                        this.changes += `Removed benefit ${benefitName} from ${newAddOn.title} Add-On\n\n`;
                    }
                });
            });
            oldAddOns.forEach((oldAddOn) => {
                if (!newPlan.addOns.some(a => a.id === oldAddOn.id)) {
                    this.changes += `Removed ${oldAddOn.title} Add-On\n\n`;
                }
            });
            //COUPONS
            const oldCoupons = oldPlan.coupons || [];
            newPlan.coupons.forEach((newCoupon) => {
                const oldCoupon = oldCoupons.find(c => c.id === newCoupon.id);
                if (!oldCoupon) {
                    this.changes += `Added coupon: "${newCoupon.title}" ($${newCoupon.dollarsOff} off)\n\n`;
                } else {
                    if (newCoupon.title !== oldCoupon.title) {
                        this.changes += `Coupon title changed from "${oldCoupon.title}" to "${newCoupon.title}"\n\n`;
                    }
                    if (newCoupon.dollarsOff !== oldCoupon.dollarsOff) {
                        this.changes += `Changed "${newCoupon.title}" coupon amount from $${oldCoupon.dollarsOff} off to $${newCoupon.dollarsOff} off\n\n`;
                    }
                }
            });
            oldCoupons.forEach((oldCoupon) => {
                if (!newPlan.coupons.some(c => c.id === oldCoupon.id)) {
                    this.changes += `Removed coupon: "${oldCoupon.title}"\n\n`;
                }
            });
            //CONTACT INFO
            if(newPlan.practiceName !== oldPlan.practiceName) {
                this.changes += `Practice name changed from ${oldPlan.practiceName} to ${newPlan.practiceName}\n\n`;
            }
            if(newPlan.practiceEmail !== oldPlan.practiceEmail) {
                this.changes += `Practice email changed from ${oldPlan.practiceEmail} to ${newPlan.practiceEmail}\n\n`;
            }
            if(newPlan.practiceWebsite !== oldPlan.practiceWebsite) {
                this.changes += `Practice website changed from ${oldPlan.practiceWebsite} to ${newPlan.practiceWebsite}\n\n`;
            }
            if(newPlan.landingPage !== oldPlan.landingPage) {
                this.changes += `Practice landing page changed from ${oldPlan.landingPage} to ${newPlan.landingPage}\n\n`;
            }
            if(newPlan.practiceAddress !== oldPlan.practiceAddress || newPlan.addressLineTwo !== oldPlan.addressLineTwo || newPlan.practiceCity !== oldPlan.practiceCity || newPlan.practiceState !== oldPlan.practiceState || newPlan.practiceZip !== oldPlan.practiceZip) {
                this.changes += `Practice address changed from "${this.formatAddress(oldPlan)}" to "${this.formatAddress(newPlan)}"\n\n`;
            }
            if(newPlan.practicePhone !== oldPlan.practicePhone) {
                this.changes += `Practice phone number changed from ${this.formatPhoneNumber(oldPlan.practicePhone)} to ${this.formatPhoneNumber(newPlan.practicePhone)}\n\n`
            }
            if(newPlan.includeBrochures !== oldPlan.includeBrochures) {
                this.changes += `Changed brochure inclusion from ${oldPlan.includeBrochures ? 'Yes' : 'No'} to ${newPlan.includeBrochures ? 'Yes' : 'No'}\n\n`;
            }
            if(newPlan.brochureStyle !== oldPlan.brochureStyle) {
                this.changes += `Brochure style changed from ${oldPlan.brochureStyle} to ${newPlan.brochureStyle}\n\n`;
            }
            if(newPlan.brochureColors !== oldPlan.brochureColors) {
                this.changes += `Brochure colors changed from ${oldPlan.brochureColors} to ${newPlan.brochureColors}\n\n`;
            }
            if(newPlan.note !== oldPlan.note) {
                this.changes += `Notes changed from "${oldPlan.note}" to "${newPlan.note}"\n\n`;
            }
            if(newPlan.planNote !== oldPlan.planNote) {
                this.changes += `Plan notes changed from "${oldPlan.planNote || ''}" to "${newPlan.planNote || ''}"\n\n`;
            }
        },
        getBenefitNameFromPlan(benefitId, newPlan, oldPlan) {
            const benefit = (newPlan.benefits || []).find(b => b.id === benefitId) || (oldPlan.benefits || []).find(b => b.id === benefitId);
            return benefit ? benefit.name : 'Unknown';
        },
        formatAddress(plan) {
            return plan.practiceAddress + ", " + (plan.addressLineTwo !== "" ? plan.addressLineTwo + " " : "") + plan.practiceCity + " " + plan.practiceState + " " + plan.practiceZip
        },
        formatPhoneNumber(phone) {
            const phoneStr = String(phone);
            if (!phoneStr || phoneStr.length === 0) return '';
            if (phoneStr.length <= 3) return `(${phoneStr}`;
            if (phoneStr.length <= 6) return `(${phoneStr.slice(0, 3)}) ${phoneStr.slice(3)}`;
            return `(${phoneStr.slice(0, 3)}) ${phoneStr.slice(3, 6)}-${phoneStr.slice(6, 10)}`;
        }
    },
    computed: {
        note: {
            get() {
                return this.$store.state.note
            },
            set(val) {
                this.setNote(val);
            }
        },
        saveButtonClickable() {
            if(this.btnText == "Changes Saved") {
                return false;
            }
            return true;
        }
    },
    created() {
        this.listChanges();
        if(this.mode === 'confirm') {
            this.btnText = "Confirm Changes";
            this.modalHeaderText = "Save Changes?";
        }
        else if(this.mode === 'revert') {
            this.btnText = "Discard Unsaved Changes";
            this.modalHeaderText = "Discard Unsaved Changes?";
        }
    }
}
</script>

<style scoped>

.full-modal {
    position: relative;
    width: 30%;
    min-width: 280px;
    max-height: 90vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    border: 3px solid var(--color-dark-blue);
    outline: 2px solid white;
    padding: 2%;
    overflow-y: auto;
    box-sizing: border-box;
}

.btn-exit {
    position: absolute;
    top: 20px;
    right: 25px;
    color: red;
    font-size: 1.75em;
    cursor: pointer;
    font-family: sans-serif
}

.top-text {
    color: var(--font-color-teal);
    flex-shrink: 0;
}

.description {
    text-align: center;
    width: 70%;
    margin-top: 0;
}

.note-box {
    margin-top: 2em;
    width: 60%;
    min-height: 220px;
    max-height: 30vh;
    outline: none;
    border: 2px solid var(--color-medium-light-gray);
    border-radius: 10px;
    resize: none;
    padding: 5px;
    font-family: 'Main';
    flex-shrink: 0;
}

.note-box:hover {
    border: 2px solid var(--color-light-blue);
}

.note-box:focus {
    border: 2px solid var(--color-bright-blue);
}

.btn-not-clickable {
    cursor: default;
}

.error {
    font-size: 0.9em;
    color: var(--color-medium-red);
    text-align: center;
    margin-top: 0.75em;
    flex-shrink: 0;
}

.save-btn {
    margin-top: 2em;
    background-color: transparent;
    outline: none;
    border: 3px solid var(--color-medium-light-gray);
    font-size: 1.5em;
    border-radius: 50px;
    cursor: pointer;
    padding: 0.25em 1em;
    color: var(--color-dark-blue);
    font-weight: 900;
    text-align: center;
    min-width: 250px;
    flex-shrink: 0;
}

.save-btn:hover, .save-btn:focus {
    border: 3px solid var(--color-dark-blue);
}

.save-btn:disabled {
    border-color: var(--color-medium-light-gray);
    color: var(--color-medium-gray);
    cursor: not-allowed;
}

.save-btn:disabled:hover {
    transform: none;
    border-color: var(--color-medium-light-gray);
}

.button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top-color: var(--color-medium-gray);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>